import script from "./CCHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CCHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CCHeader.vue?vue&type=style&index=0&id=37ad198a&scoped=true&lang=less"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ad198a"]])

export default __exports__